
export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          <div className="flex items-center space-x-3 sm:space-x-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <i className="ri-government-line text-white text-lg sm:text-xl"></i>
            </div>
            <div>
              <h1 className="text-base sm:text-xl font-bold text-gray-900 whitespace-nowrap">규제환경 대시보드</h1>
              <p className="text-xs text-gray-500 hidden sm:block">지자체 규제환경 분석 시스템</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 sm:space-x-4">
            <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
              <i className="ri-notification-3-line text-lg sm:text-xl"></i>
            </button>
            <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
              <i className="ri-settings-3-line text-lg sm:text-xl"></i>
            </button>
            <div className="hidden sm:flex items-center space-x-2 sm:space-x-3 pl-2 sm:pl-4 border-l border-gray-200">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                <i className="ri-user-line text-gray-600"></i>
              </div>
              <div className="hidden lg:block">
                <div className="text-xs sm:text-sm font-medium text-gray-900">관리자</div>
                <div className="text-xs text-gray-500">admin@example.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
